import { ERouteName } from '~/app/router';

export const ETrackerPages = {
  CATALOG: 'catalogScreen', // main
  FAVORITES: 'favoritesScreen',
  ITEM: 'itemScreen',
  PRODUCT: 'productScreen',
  SEARCH: 'searchScreen',
  EMPTY_SEARCH: 'emptySearchScreen',
  CART: 'cartScreen',
  CHECKOUT: 'checkoutScreen',
  SHOP: 'shopScreen',
  ORDER_STATUS: 'orderStatus',

  /// new pages
  ABOUT: 'aboutScreen',
  ABOUT_CAREERS: 'aboutCareersScreen',
  ABOUT_CONTACT: 'aboutContactScreen',
  ABOUT_DELIVERY_POINTS: 'aboutDeliveryPointsScreen',
  FAQ: 'faqScreen',
  USER_SETTINGS: 'personal',
  USER_COMPANY: 'company',
  USER_COMPANIES: 'companies',
  USER_ACCOUNT: 'companyAccount',
  CATEGORY: 'categoryScreen',
  AUTH: 'auth',
} as const;

const ROUTES_MAP = new Map<ERouteName, TTrackerPages>([
  [ERouteName.ABOUT, ETrackerPages.ABOUT],
  [ERouteName.ABOUT_CAREERS, ETrackerPages.ABOUT_CAREERS],
  [ERouteName.ABOUT_CONTACT, ETrackerPages.ABOUT_CONTACT],
  [ERouteName.ABOUT_DELIVERY_POINTS, ETrackerPages.ABOUT_DELIVERY_POINTS],
  [ERouteName.SEARCH, ETrackerPages.SEARCH],
  [ERouteName.CART,  ETrackerPages.CART],
  [ERouteName.FAVORITES, ETrackerPages.FAVORITES],
  [ERouteName.CHECKOUT, ETrackerPages.CHECKOUT],
  [ERouteName.FAQ, ETrackerPages.FAQ],
  [ERouteName.USER, ETrackerPages.USER_SETTINGS],
  [ERouteName.USER_ORDERS, ETrackerPages.ORDER_STATUS],
  [ERouteName.USER_SETTINGS, ETrackerPages.USER_SETTINGS],
  [ERouteName.USER_COMPANY, ETrackerPages.USER_COMPANY],
  [ERouteName.USER_COMPANIES, ETrackerPages.USER_COMPANIES],
  [ERouteName.USER_ACCOUNT, ETrackerPages.USER_ACCOUNT],
  [ERouteName.CATEGORY, ETrackerPages.ITEM], // <-- ЭТО КАТЕГОРИЯ или ПОДБОРКА
  [ERouteName.PRODUCT, ETrackerPages.PRODUCT],
  [ERouteName.SHOP, ETrackerPages.SHOP],
  [ERouteName.MAIN, ETrackerPages.CATALOG], // <-- ЭТО ГЛАВНАЯ
]);

export type TTrackerPages = (typeof ETrackerPages)[keyof typeof ETrackerPages];

export const routeNameToTrackerPages = (route: ERouteName) => ROUTES_MAP.get(route);
